<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        version="1.1"
        xmlns:dc="http://purl.org/dc/elements/1.1/" 
        xmlns:cc="http://creativecommons.org/ns#" 
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" 
        xmlns:svg="http://www.w3.org/2000/svg" 
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" 
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" 
        sodipodi:docname="plus-sign.svg" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink"  
        :width="iconWidth" 
        :height="iconHeight"
        viewBox="0 0 1200 1200" 
        enable-background="new 0 0 1200 1200" 
        xml:space="preserve"
    >
        <path 
            inkscape:connector-curvature="0" 
            d="M600,0C268.629,0,0,268.629,0,600s268.629,600,600,600
            s600-268.629,600-600S931.371,0,600,0z M504.199,261.841h191.602v242.358h242.358v191.602H695.801v242.358H504.199V695.801H261.841
            V504.199h242.358V261.841z"
            fill="currentColor"
        />
    </svg>
</template>